import { type AxiosInstance } from 'axios';

import type { CommonListArgs, Nullable, PaginatedList } from './types.ts';

export class IGolfApi {
  constructor(private instance: AxiosInstance) {}

  public async getClubsBySearch(params: ClubsListArgs) {
    return this.instance
      .get<PaginatedList<IGolfCourseSearch>>(`/igolf/courses/search`, { params })
      .then((res) => res.data);
  }

  public async getCachedClubs() {
    return this.instance.get<IGolfCourseSearch[]>(`/igolf/courses/`).then((res) => res.data);
  }

  public async getCourseById(params: IGolfCourseQueryParams) {
    return this.instance
      .get<IGolfCourseDetail>(`/igolf/courses/${params.id_course}/`)
      .then((res) => res.data);
  }
}

export type ClubsListArgs = {
  search?: string;
} & CommonListArgs;

export type IGolfCourseQueryParams = {
  id_course?: string;
};

export type IGolfCourseSearch = {
  id_course: string;
  course_name: string;
  address: string;
  latitude: Nullable<string>;
  longitude: Nullable<string>;
  is_added: boolean;
};

export type IGolfGeometryPoint = {
  lat: number;
  lon: number;
};

export type IGolfGeometryShape = {
  points: IGolfGeometryPoint[];
};

export type IGolfHoleGeometry = {
  green?: IGolfGeometryShape[];
  fairway?: IGolfGeometryShape[];
  perimeter?: IGolfGeometryShape[];
  bunkers?: IGolfGeometryShape[];
  teeboxes?: IGolfGeometryShape[];
  central_path?: IGolfGeometryShape[];
  green_center?: IGolfGeometryShape[];
  teebox_centers?: IGolfGeometryShape[];
};

export type IGolfCourseHole = {
  id: string;
  hole_number: number;
  men_par?: Nullable<number>;
  wmn_par?: Nullable<number>;
  men_handicap?: Nullable<number>;
  wmn_handicap?: Nullable<number>;
  front_lat?: Nullable<string>;
  front_lon?: Nullable<string>;
  center_lat?: Nullable<string>;
  center_lon?: Nullable<string>;
  back_lat?: Nullable<string>;
  back_lon?: Nullable<string>;
  tee_points?: unknown;
  custom_points?: unknown;
  geometry: IGolfHoleGeometry;
};

export type IGolfCourseTee = {
  id_tee?: Nullable<number>;
  gender?: Nullable<string>;
  medal_rating?: Nullable<string>;
  slope?: Nullable<string>;
  tee_name?: Nullable<string>;
  tee_color?: Nullable<string>;
};

export type IGolfCourseDetail = {
  id_course: string;
  course_name: string;
  active?: boolean;
  address1?: string;
  address2?: string;
  city?: string;
  zip_code?: string;
  latitude?: Nullable<string>;
  longitude?: Nullable<string>;
  email?: string;
  phone?: string;
  url?: string;
  layout_holes?: Nullable<number>;
  layout_total_holes?: Nullable<number>;
  layout_name?: string;
  class_name?: string;
  dress_code?: string;
  id_language?: Nullable<number>;
  id_country_default_language?: Nullable<number>;
  recommend_rating?: Nullable<string>;
  gps_available?: boolean;
  seasonal?: Nullable<boolean>;
  details_loaded: boolean;
  details_loaded_at?: Nullable<string>;
  gps_markup: Nullable<unknown>;
  holes: IGolfCourseHole[];
  tees: IGolfCourseTee[];
};
